import { render, staticRenderFns } from "./OrganizerSidebar.vue?vue&type=template&id=cbe36708&scoped=true"
import script from "./OrganizerSidebar.vue?vue&type=script&lang=js"
export * from "./OrganizerSidebar.vue?vue&type=script&lang=js"
import style0 from "./OrganizerSidebar.vue?vue&type=style&index=0&id=cbe36708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe36708",
  null
  
)

export default component.exports